<template>
    <div v-if="user" class="user">
        <div class="space" v-if="editable" />
        <div class="user-inner">
            {{ user.eventNickName || user.name || defaultName }}
        </div>
        <div v-if="editable" class="change space" @click="$emit('click')">
            更改
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        editable: Boolean,
    },
    computed: {
        ...mapState({
            defaultName: (state) => state.defaultName,
            user: (state) => state.user,
        }),
    },
};
</script>

<style lang="scss" scoped>
.user {
    padding: 0 20px;
    font-size: 20px;
    color: #4683bc;
    width: 80%;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border-radius: 23.5px;
    box-shadow: 0 2px 11px 0 rgba(0, 152, 201, 0.37);
    .user-inner {
        max-width: 90%;
        margin: auto;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .change {
        cursor: pointer;
        white-space: nowrap;
        font-size: 18px;
        color: #888;
    }
    .space {
        width: 36px;
    }
}
</style>
